// Gold Barbershop Data - Staff and Services

export const branches = {
  smichov: {
    id: 'smichov',
    name: 'Smíchov',
    address: 'Plzeňská 2298/170, 150 00 Praha 5',
    phone: '+420 608 189 878'
  },
  stodulky: {
    id: 'stodulky',
    name: 'Stodůlky',
    address: 'Suchý vršek 2122/33, 158 00 Praha 5',
    phone: '+420 731 433 926'
  }
};

export const staff = {
  smichov: [
    { id: 'lenny', name: 'Lenny', role: 'barber', pin: '0000', avatar: '/staff/Lenny.webp' },
    { id: 'samik', name: 'Samik', role: 'barber', pin: '0000', avatar: '/staff/Samuel.jpeg' }
  ],
  stodulky: [
    { id: 'gabriel', name: 'Gabriel', role: 'admin', pin: '2308', avatar: '/staff/barber_gabriel.png' },
    { id: 'luiz', name: 'Luiz', role: 'admin', pin: '1405', avatar: '/staff/barber_luiz.png' },
    { id: 'adam', name: 'Adam', role: 'barber', pin: '1604', avatar: '/staff/Adam.jpg' }
  ]
};

export const services = {
  smichov: [
    { id: 's1', name: 'GOLD klasický střih', duration: '45 min', price: 600 },
    { id: 's2', name: 'GOLD Střih + vousy', duration: '1h', price: 890 },
    { id: 's3', name: 'GOLD Úprava vousů', duration: '25 min', price: 450 },
    { id: 's4', name: 'Barvení a úprava vousů', duration: '30 min', price: 700 },
    { id: 's5', name: 'GOLD Střih dlouhých vlasů', duration: '1h', price: 750 },
    { id: 's9', name: 'GOLD Dlouhé vlasy + vousy', duration: '1h', price: 1090 },
    { id: 's6', name: 'Barvení a střih vlasů', duration: '1h', price: 1000 },
    { id: 's7', name: 'GOLD Dětský střih do 12 let', duration: '30 min', price: 450 },
    { id: 's8', name: 'GOLD Hot towel holení', duration: '30 min', price: 550 }
  ],
  stodulky: [
    { id: 't1', name: 'Klasický střih', duration: '30 min', price: 550 },
    { id: 't2', name: 'Střih + Vousy', duration: '1h', price: 790 },
    { id: 't3', name: 'Úprava vousů', duration: '25 min', price: 400 },
    { id: 't4', name: 'Úprava vousů a barvení vousů', duration: '45 min', price: 650 },
    { id: 't5', name: 'Střih dlouhých vlasů', duration: '45 min', price: 650 },
    { id: 't13', name: 'Dlouhé vlasy + vousy', duration: '60 min', price: 950 },
    { id: 't6', name: 'Střih + Barvení vlasů', duration: '1h', price: 1000 },
    { id: 't7', name: 'Pánský melír', duration: '3h 20min', price: 1000 },
    { id: 't8', name: 'Styling vlasů', duration: '5 min', price: 140 },
    { id: 't9', name: 'Střih strojkem', duration: '20 min', price: 400 },
    { id: 't10', name: 'Dětský střih do 12 let', duration: '30 min', price: 400 },
    { id: 't11', name: 'Panský střih, Úprava a barvení vousů', duration: '1h', price: 1350 },
    { id: 't12', name: 'Panský střih a Úprava a barvení vlasů i vousů', duration: '1h 30min', price: 1990 }
  ]
};

// Format price to Czech format
export const formatPrice = (price) => {
  return new Intl.NumberFormat('cs-CZ', {
    style: 'currency',
    currency: 'CZK',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
  }).format(price);
};
